<template>
    <div class="__wrapper">
        <div class="holder" :class="{ __hide: !showStep2, __show : showStep2 }">
            <div class="__container grided">
            <div class="__section-center">
                <h2>All consultants 65</h2>
                <h1>30 DAYS FREE TRIAL</h1>
                <span>Full secure price is 1 USD per managed consultant.</span>
                <span>Send the request and get permission to manage.</span>
                <div class="card">
                    <div class="item" v-for="(person,i) in consultants">
                        <div>
                            <img :src="$fullUrl('images/profiles/'+person.profile_picture)">
                            <span>{{person.first_name+' '+person.last_name | validate }}</span>
                        </div>
                        <span>1 $</span>
                        <input type="checkbox" :value="person.id" v-model="people">
                    </div>
                </div>
            </div>
            <div class="__section-right">
                <h3>Payment infos</h3>
                <div class="box">
                    <p>{{people.length | validate }} Consultants</p>
                </div>
                <div class="row end">
                    <span class="colored">Due Total</span>
                    <span>{{people.length | validate }} $</span>
                </div>
                <div ref="paypal"></div>
            </div>
        </div>
        </div>
        <div class="holder" :class="{ __hide: !showStep1, __show : showStep1 }">
            <div class="__container centered">
                <div class="__cont">
                    <h1 class="__colored">Get A 30 days free trial</h1>
                    <h3>Manage your consultants:</h3>
                    <div class="icons">
                        <div>
                            <img src="../assets/icons/icon1.svg">
                            <h2>Profile</h2>
                        </div>
                        <div>
                            <img src="../assets/icons/icon2.svg">
                            <h2>Skills</h2>
                        </div>
                        <div>
                            <img src="../assets/icons/icon3.svg">
                            <h2>Availability</h2>
                        </div>
                        <div>
                            <img src="../assets/icons/icon4.svg">
                            <h2>Leads</h2>
                        </div>
                    </div>
                    <div class="height"></div>
                    <div class="button">
                        <span @click="showStep2 = true">Get started</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        name: "PurchaseCompany",
        data() {
           return {
               people : [],
               showStep1 : true,
               showStep2 : false,
           }
        },
        computed: {
            ...mapGetters([
                "getCompany",
            ]),
            consultants(){
                return this.getCompany.consultants;
            }
        },
        mounted(){
            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?client-id=AVd2qMJcBeQC__Hh4mbawCElGnLE-z4jdQr1LUI1d7fe354nrG-ofuxEzRI-4bbYNHr9eqoxXvwzwed7";
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
            this.$store.dispatch("GET_COMPANY_INFO",{id : this.$route.params.id});

        },
        methods : {
            setLoaded: function() {
                window.paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            return actions.order.create({
                                purchase_units: [
                                    {
                                        description: 'pay for these consultants',
                                        amount: {
                                            currency_code: "USD",
                                            value: this.people.length
                                        }
                                    }
                                ]
                            });
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            if (order.status === "COMPLETED")
                                this.buy()
                            else
                                console.log(order.status)
                        },
                        onError: err => {
                            console.log(err);
                        }
                    })
                    .render(this.$refs.paypal);
            },
            buy(){
                this.$store.dispatch("BUY_COMPANY", {company : this.$route.params.id, consultants : this.people})
            }
        },
        watch : {
            showStep1 : function (val) {
                if (val)
                    this.showStep2 = false
            },
            showStep2 : function (val) {
                if (val)
                    this.showStep1 = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .__wrapper{
        background: #FFF;
        min-height: 93%;
        position: relative;
        .holder{
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            top: 0;
            .__container{
                margin: 0 auto;
                width: 70%;
            }
            .grided{
                display: grid;
                grid-template-columns: 4fr 1.5fr;
                grid-column-gap: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                    grid-template-columns: 1fr;
                    width: 90%;
                }
            }
            .centered{
                height: 100%!important;
            }
        }
    }
    .__section-center{
        display: flex;
        flex-direction: column;
        h2{
            color: #2C2C2C;
            font-size: 28px;
            margin-top: 20px;
            font-weight: normal;
        }
        h1{
            color: #1999A7;
            font-size: 25px;
            margin-top: 20px;
            margin-bottom: 30px;
            font-weight: lighter;
        }
        span{
            font-size: 18px;
            color: #2C2C2C;
            font-weight: lighter;
        }
        .card{
            border: 0.5px solid rgba(112,112,112,0.4);
            padding: 5px;
            margin-top: 10px;
            .item{
                display: flex;
                padding: 5px 30px;
                justify-content: space-between;
                &:nth-of-type(odd){
                    background: #EDEDED;
                    input[type=checkbox]{
                        background: #FFF;
                    }
                }
                &:nth-of-type(even){
                    input[type=checkbox]{
                        background: #EDEDED;
                    }
                }
                div{
                    display: flex;
                    img{
                        margin-right: 20px;
                        width: 35px;
                        height: 35px;
                        border-radius: 100%;
                    }
                    span{
                        color: #1885AD;
                        font-size: 14px;
                    }
                }
                span{
                    color: #707070;
                    font-size: 14px;
                    margin-top: 6px;
                }
                input[type=checkbox]{
                    background: #FFF;
                    outline: none;
                    margin-left: 10px;
                    margin-top: 3px;
                    padding-left:5px;
                    padding-right:5px;
                    -webkit-appearance:button;
                    color:#707070;
                    white-space: nowrap;
                    overflow:hidden;
                    border-radius: 5px;
                    width:20px;
                    height:20px;
                    &:checked{
                        background-color:#707070;
                    }
                }
            }
        }
    }
    .__section-right{
        display: flex;
        margin-top: 20px;
        padding-top: 100px;
        flex-direction: column;
        img{
            margin: 10px 0;
        }
        h3{
            color: #000;
            font-size: 18px;
        }
        .box{
            background: #EDEDED;
            padding: 20px;
            margin-top: 60px;
            .row{
                display: flex!important;
                img{
                    margin-left: 10px;
                    width: 30px;
                    height: 30px;
                }
                input{
                    color: #939393;
                    background: #FFF;
                    padding: 5px 10px;
                    width: 100%;
                    margin-right: 10px;
                    border-radius: 5px;
                    outline: none;
                    box-shadow: 0 3px 2px rgba(0,0,0,0.16);
                }
            }
        }
    }
    .row{
        display: flex!important;
        img{
            margin-left: 10px;
            width: 30px;
            height: 30px;
            margin-bottom: 20px;
        }
        input{
            color: #939393;
            background: #FFF;
            padding: 5px 10px;
            width: 100%;
            margin-right: 10px;
            margin-bottom: 10px;
            border-radius: 5px;
            outline: none;
            box-shadow: 0 3px 2px rgba(0,0,0,0.16);
        }
    }
    .end{
        justify-content: space-between;
        padding-left: 20px;
        margin-top: 10px;
        padding-right: 20px;
        margin-bottom: 20px;
    }
    .btn{
        background: #1999A7;
        color: #FFF;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px;
        justify-content: center;
        align-items: center;
        display: flex;
        span{
            color: #FFF;
        }
    }
    .__hide{
        opacity: 0;
        pointer-events: none;
        animation: slide-out 0.9s forwards;
        -webkit-animation: slide-out 0.9s forwards;
    }
    .__show{
        opacity: 1;
        pointer-events: auto;
        /*animation: slide-in 0.5s forwards;*/
        /*-webkit-animation: slide-in 0.5s forwards;*/
    }
    .__cont{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        flex-direction: column;
        h1{
            color: #1999A7;
            text-align: center;
            margin-top: 50px;
            font-size: 32px;
        }
        h3{
            color: #1885AD;
            font-size: 22px;
            margin-top: 40px;
            margin-bottom: 40px;
            text-align: center;
        }
        .icons{
            display: flex;
            justify-content: space-between;
            width: 60%;
            margin: 0 auto;
            div{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                h2{
                    color: #707070;
                    font-size: 24px;
                    margin-bottom: 30px;
                }
                img{
                    width: 40px;
                    text-align: center;
                    height: 40px;
                    margin-bottom: 20px;
                    margin-top: 20px;
                }
            }
        }
        .button{
            background: #1885AD;
            color: #FFF;
            border-radius: 5px;
            display: flex;
            cursor: pointer;
            width: 30%;
            margin: 0 auto;
            padding: 10px;
            align-items: center;
            justify-content: center;
            span{
                color: #FFF;
            }
        }
    }
    .height{
        height: 50px;
    }
</style>